// GraphQL
import {
    ApolloClient,
    createHttpLink,
    InMemoryCache,
  } from "@apollo/client";
  import { local } from 'data/lib/local-json'
  import { setContext } from '@apollo/client/link/context';

  const httpLink = createHttpLink({
    uri: process.env.SEMAPHORE_API
  });

  const authLink = setContext((_, { headers }) => {
    const token = local("auth.token");
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      }
    }
  });

  export const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
  })